export default "__VITE_ASSET__CkRiUI24__"